import {toast} from 'react-toastify';

const INITIAL_STATE = {
  todos: [],
  especifico: {
    id: 0,
    status: "",
    endereco:{},
    dataInicio: new Date(),
    emailComissao: "",
    dono: {
      nome: ""
    },
    formandos: [],
    itens: []
  },
  esconderAlertaPlanilha: false,
  carregando: false,
  erro: null,
  ultimo: null
};

export default (state = INITIAL_STATE, action) => {
  switch(action.type){
    case 'REQUISITAR_CONTRATO':
      return {...state, carregando: true};
    case 'ERRO_CONTRATO':
      toast.error(action.erro.message, {autoClose: false});
      return {...state, carregando: false, erro: action.erro};
    case 'OBTER_TODOS_CONTRATOS':
      return {...state, carregando: false, todos: action.contratos};
    case 'OBTER_ESPECIFICO':
      return {...state, carregando: false, especifico: action.contrato};
    case 'OBTER_ESPECIFICO_USUARIO':
      // Validação e sanitização dos dados do contrato
      if (!action.contrato || typeof action.contrato !== 'object') {
        console.error('Contrato inválido recebido:', action.contrato);
        return {...state, carregando: false, erro: new Error('Dados do contrato inválidos')};
      }

      // Filtrar publicações visíveis com validação
      let publicacoesFiltradas = [];
      try {
        if (Array.isArray(action.contrato.publicacoes)) {
          publicacoesFiltradas = action.contrato.publicacoes.filter(p =>
            p && typeof p === 'object' && p.visivel
          );
        }
      } catch (error) {
        console.error('Erro ao filtrar publicações:', error);
        publicacoesFiltradas = [];
      }

      const contratoAtualizado = {
        ...action.contrato,
        publicacoes: publicacoesFiltradas
      };
      return {...state, carregando: false, especifico: contratoAtualizado};
    case 'SALVAR_ENDERECO':
      toast.success("Informaçãoes de entrega atualizadas", 5000);
      return {...state, especifico: {...state.especifico, endereco: action.endereco, enderecoPreenchido: true}, carregando: false};
    case 'PLANILHA_DISTRIBUICAO_APROVADA':
      if (action.status) {
        toast.success("Planilha aprovada com sucesso!", 5000);
      }
      return {...state, esconderAlertaPlanilha: true};
    case 'NOVO_CONTRATO':
      toast.success("Contrato cadastrado com sucesso.", 5000);
      return {...state, carregando: false, todos: state.todos.concat(action.contrato), ultimo: action.contrato};
    case 'ALTERAR_CONTRATO':
      // Validação dos dados recebidos
      if (!action.contrato || typeof action.contrato !== 'object') {
        console.error('Contrato inválido para alteração:', action.contrato);
        return {...state, carregando: false, erro: new Error('Dados do contrato inválidos')};
      }

      // Mesclar o contrato atualizado com os dados relacionais existentes
      let especifico = {
        ...state.especifico,  // Mantém todos os campos existentes
        ...action.contrato,   // Atualiza com os novos valores
        formandos: Array.isArray(action.contrato.formandos) ? action.contrato.formandos : (state.especifico.formandos || []),
        dono: (action.contrato.dono && typeof action.contrato.dono === 'object') ? action.contrato.dono : (state.especifico.dono || {}),
        usuario: (action.contrato.usuario && typeof action.contrato.usuario === 'object') ? action.contrato.usuario : (state.especifico.usuario || {}),
        itens: Array.isArray(action.contrato.itens) ? action.contrato.itens : (state.especifico.itens || [])
      };
      return {...state, carregando: false, todos: state.todos.filter((contrato) => {return contrato.id!==action.contrato.id}).concat(action.contrato), especifico};
    case 'REMOVER_CONTRATO':
      toast.success("Contrato removido com sucesso.", 5000);
      return {...state, carregando: false, todos: state.todos.filter((contrato) => {return contrato.id!==action.id})};
      case 'TRANSFERIR_CONTRATO':
        toast.success("Contrato tranferido com sucesso.", 5000);
        return {...state, carregando: false, todos: state.todos.filter((contrato) => {return contrato.id!==action.contrato.id}).concat(action.contrato)};
    default:
      return state;
  }
};
